export default {
  path: "/user/cpa/torneos",
  component: () => import("@/views/user/cpa/torneos/TorneosLayout.vue"),
  meta: {
    requiresAuth: true,
    requiresCurso: true,
    requiresCpaDirectiva: true,
  },
  children: [
    {
      path: "",
      name: "torneos-dashboard",
      component: () => import("@/views/user/cpa/torneos/TorneosDashboard.vue"),
    },
    {
      path: "nuevo",
      name: "torneos-nuevo",
      component: () => import("@/views/user/cpa/torneos/TournamentEditorView.vue"),
    },
    {
      path: ":tournamentId",
      name: "torneos-editar",
      component: () => import("@/views/user/cpa/torneos/TournamentEditorView.vue"),
      props: true,
    },
    {
      path: ":tournamentId/configuracion",
      name: "torneos-configuracion",
      component: () => import("@/views/user/cpa/torneos/TournamentConfigView.vue"),
      props: true,
    },
    {
      path: ":tournamentId/inscripciones",
      name: "torneos-inscripciones",
      component: () => import("@/views/user/cpa/torneos/RegistrationsView.vue"),
      props: true,
    },
    {
      path: ":tournamentId/equipos",
      name: "torneos-equipos",
      component: () => import("@/views/user/cpa/torneos/TeamsView.vue"),
      props: true,
    },
    {
      path: ":tournamentId/equipos/:teamId",
      name: "torneos-equipo-detalle",
      component: () => import("@/views/user/cpa/torneos/TeamDetailView.vue"),
      props: true,
    },
    {
      path: ":tournamentId/fixture",
      name: "torneos-fixture",
      component: () => import("@/views/user/cpa/torneos/FixtureView.vue"),
      props: true,
    },
    {
      path: ":tournamentId/resultados",
      name: "torneos-resultados",
      component: () => import("@/views/user/cpa/torneos/ResultsView.vue"),
      props: true,
    },
    {
      path: ":tournamentId/tabla",
      name: "torneos-tabla",
      component: () => import("@/views/user/cpa/torneos/StandingsView.vue"),
      props: true,
    },
    {
      path: ":tournamentId/estadisticas",
      name: "torneos-estadisticas",
      component: () => import("@/views/user/cpa/torneos/PlayerStatsView.vue"),
      props: true,
    },
    {
      path: ":tournamentId/premios",
      name: "torneos-premios",
      component: () => import("@/views/user/cpa/torneos/AwardsView.vue"),
      props: true,
    },
    {
      path: ":tournamentId/chess/jugadores",
      name: "torneos-chess-jugadores",
      component: () => import("@/views/user/cpa/torneos/ChessPlayersView.vue"),
      props: true,
    },
    {
      path: ":tournamentId/chess/seeds",
      name: "torneos-chess-seeds",
      component: () => import("@/views/user/cpa/torneos/ChessSeedsView.vue"),
      props: true,
    },
    {
      path: ":tournamentId/chess/rondas",
      name: "torneos-chess-rondas",
      component: () => import("@/views/user/cpa/torneos/ChessRoundsView.vue"),
      props: true,
    },
    {
      path: ":tournamentId/chess/tabla",
      name: "torneos-chess-tabla",
      component: () => import("@/views/user/cpa/torneos/ChessStandingsView.vue"),
      props: true,
    },
  ],
};
